module.exports = __webpack_public_path__ + "static/media/config.dd08baa8.svg";